import React from 'react';
import { ListViewMenu } from '~/components';
import { useIntegrations } from '~/contexts';
import { accountingProviders } from '~/lookups';

export default function InvoiceAccountingActions({
  accountingSynced,
  accountingProvider,
  disabled,
  tooltip,
  Container = ListViewMenu.Item,
  onSave,
  onReload,
}) {
  const integrations = useIntegrations();

  if (accountingSynced && accountingProvider) {
    const accountingProviderName = accountingProviders[accountingProvider].name;
    return (
      <Container disabled={disabled} tooltip={tooltip} onClick={() => onReload(accountingProvider)}>
        Reload from {accountingProviderName}
      </Container>
    );
  }

  if (accountingProvider) {
    const accountingProviderName = accountingProviders[accountingProvider].name;
    return (
      <Container disabled={disabled} tooltip={tooltip} onClick={() => onSave(accountingProvider)}>
        Save to {accountingProviderName}
      </Container>
    );
  }

  // No accountingProvider → show save for all installed integrations
  return Object.entries(accountingProviders).map(([accountingProvider, type]) => {
    if (!integrations[accountingProvider]) return null;
    return (
      <Container
        key={accountingProvider}
        disabled={disabled}
        tooltip={tooltip}
        onClick={() => onSave(accountingProvider)}>
        Save to {type.name}
      </Container>
    );
  });
}
